import { IconButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/IconButton';
import React, { FC } from 'react';
import styles from './Questionnaire.module.scss';
import CheckedQuestionnaireIcon from '@lmt/unicorn-shared/app/icons/questionnaire-checked.svg?react';
import QuestionnaireIcon from '@lmt/unicorn-shared/app/icons/questionnaire.svg?react';
import { useGlobalForms } from '@lmt/unicorn-shared/app/components/global-forms/useGlobalForms';
import { useDataBlockType } from '@lmt/shared-types';
import i18next from 'i18next';

export interface Questionnaire {
  passed: boolean;
  dataBlockId: number;
  dataBlockTypeId: number;
}

export const QuestionnaireButton: FC<Questionnaire> = (props) => {
  const forms = useGlobalForms();
  const dataBlockType = useDataBlockType(props.dataBlockTypeId);

  return (
    <div
      className={styles.container}
      data-statistic-info={props.passed}
      data-test-id="data-block-statistic-icon"
    >
      <IconButton
        color="grey"
        iconComponent={
          props.passed ? (
            <CheckedQuestionnaireIcon
              data-icon-multicolor={true}
              className={styles.icon}
            />
          ) : (
            <QuestionnaireIcon
              data-icon-multicolor={true}
              className={styles.icon}
            />
          )
        }
        onClick={() =>
          forms.openDataBlockStatisticEditing(
            props.dataBlockId,
            props.dataBlockTypeId,
            i18next.t('data_blocks.statistics_title', {
              type: dataBlockType?.value,
            }),
          )
        }
      />
    </div>
  );
};
